import React from "react";
import PracticeSimulatorVoicePage from "./PracticeSimulatorVoicePage";
import useStudyBuddyIframeHeight from "./useStudyBuddyIframeHeight";

export default function PracticeSimulatorVoiceEmbedPage() {
  const ref = useStudyBuddyIframeHeight();
  return <div ref={ref}><PracticeSimulatorVoicePage embed/></div>;
}
